import { Card } from "@material-ui/core";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import firebase_ from "../../../firebase/firebase";
import "./UsersList.css";
function UsersList() {
  const [users, setUsers] = useState([]);
  const [userId, setUsersId] = useState([]);
  const db = firebase_.firestore();
  async function fetchUsers() {
    setUsers([]);
    await db
      .collection("Users")
      .get(users)
      .then((res) => {
        res.forEach((item) => {
          setUsers((users) => [...users, item.data()]);
          setUsersId((userId) => [...userId, item.id]);
        });
      })
      .catch((err) => {
        console.log("error in fetching Users", err);
      });
  }
  useEffect(() => {
    fetchUsers();
  }, []);

  return (
    <div>
      <div>
        {users.map((item, index) => {
          return (
            <Link className="user-card-link" to={`/admin/${item.emailId}/task`}>
              <Card className="users-card">
                <p>{item.userName}</p>
                <p>{item.emailId}</p>
              </Card>
            </Link>
          );
        })}
      </div>
    </div>
  );
}

export default UsersList;
